<template>
  <div class="cdf">
    <div class="cdf-hero">
      <div class="cdf-hero__left">
        <div class="cdf-hero__avatar">
          <i class="fa-light fa-database" />
        </div>
        <div class="cdf-hero__identity">
          <h2 class="cdf-hero__name">
            {{ selectedData.schemaName }}
          </h2>
          <div class="cdf-hero__meta">
            <DataExplorerLink
              :id="selectedData.idShopContact"
              :value="selectedData.contactTabLabel || 'Contact'"
              :show-icon="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="cdf-content">
      <div class="cdf-card">
        <CustomObjects
          :custom-object-id="selectedData.idDefinition"
          :context="customObjectsContext"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useStore } from '@/store';
import CustomObjects from '@/views/my-shop-data/CustomObjects.vue';
import DataExplorerLink from '@/components/data-explorer/fields/DataExplorerLink.vue';

export default defineComponent({
  name: 'CustomDataFile',
  components: {
    CustomObjects,
    DataExplorerLink,
  },
  setup() {
    const store = useStore();
    const selectedData = computed(() => store.getters['dataExplorer/getSelectedData']);
    const customObjectsContext = computed(() => ({
      mode: 'embedded',
      relation: {
        target: 'contact',
        id: selectedData.value?.idShopContact,
        sourceField: selectedData.value?.sourceField,
      },
      ui: {
        showHeader: false,
        showBackLink: false,
        showImport: false,
        showFilters: false,
      },
    }));

    return {
      selectedData,
      customObjectsContext,
    };
  },
});
</script>

<style scoped lang="scss">
.cdf {
  padding: 1.25rem;
}

.cdf-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #e5e7eb;

  &__left {
    display: flex;
    align-items: center;
    gap: 0.875rem;
  }

  &__avatar {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, #84cc16, #65a30d);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
      color: #fff;
      font-size: 1.25rem;
    }
  }

  &__identity {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  &__name {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
    line-height: 1.2;
  }

  &__meta {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.8125rem;
  }
}

.cdf-content {
  padding: 0 0.125rem;
}

.cdf-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  padding: 0.75rem 0.875rem;
}

.cdf-card :deep(.custom-objects-page) {
  min-height: auto;
}

.cdf-card :deep(.page-content) {
  padding: 0;
}
</style>
